























































import { Component, Vue } from 'vue-property-decorator';
import { MemberProfileRequest } from '../../types/request';
import { ObjectFactory } from '../../config/objectFactory';
import { MedTransGoConstants } from '../../util/constants';
import { CommonUtils } from '@/util/commonUtils';
@Component({})
export default class AccountSetup extends Vue {

    private memberProfileRequest: MemberProfileRequest = {
          memberType: 'ORG_MANAGER',
          organizationType: 'NEW_ORG',
          auctionEnabled: false,
          organizationAddress: {
              fullAddress: '',
          },
          locationAddress: {
              fullAddress: '',
          },
          referralSource: '',
          sourceAnswer: '',
          sourceDetailsQuestion: '',
          sourceDetailsAnswer: '',
    };
    public mounted() {
        const iCacheService = ObjectFactory.getCacheService();
        const value = iCacheService.getValue(MedTransGoConstants.FIELD_MEMBER_PROFILE);
        if (value) {
            this.memberProfileRequest = value;
        }
        this.$on(MedTransGoConstants.EVENT_SAVE_MEMBER_REQUEST, () => {
            iCacheService.saveValue(MedTransGoConstants.FIELD_MEMBER_PROFILE, this.memberProfileRequest);
        });
    }
    private logout() {
        CommonUtils.logout(this.$store.state);
    }
}
